<template>
  <el-dropdown
    class="base-range-selector"
    :popper-class="popperClass"
    trigger="click"
    :disabled="disabled"
    @command="onChange"
  >
    <button class="base-range-selector__btn" type="button" :disabled="disabled">
      <span v-if="label" class="base-range-selector__label">{{ label }}:</span>
      <span class="base-range-selector__value">{{ currentLabel }}</span>
      <svg class="base-range-selector__chevron" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="opt in options"
        :key="opt.value"
        :command="opt.value"
        :class="{ 'is-active': value === opt.value }"
      >
        {{ opt.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { Dropdown, DropdownMenu, DropdownItem } from 'element-ui';

export default {
  name: 'base-range-selector',
  components: {
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem
  },
  props: {
    value: { type: [String, Number], default: '' },
    options: {
      type: Array,
      required: true,
      validator: arr => Array.isArray(arr) && arr.every(o => o && 'value' in o && 'label' in o)
    },
    label: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    currentLabel() {
      const opt = this.options.find(o => o.value === this.value);
      return opt ? opt.label : '';
    },
    popperClass() {
      return 'base-range-selector__popper';
    }
  },
  methods: {
    onChange(value) {
      if (this.value === value) return;
      this.$emit('input', value);
      this.$emit('change', value);
    }
  }
};
</script>

<style lang="scss" scoped>
.base-range-selector {
  display: inline-block;
}

.base-range-selector__btn {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 0 12px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
    border-color: rgba(255, 255, 255, 0.3);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.base-range-selector__label {
  color: rgba(255, 255, 255, 0.7);
  font-weight: 600;
  font-size: 11px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  line-height: 1;
}

.base-range-selector__value {
  color: #fff;
  font-weight: 600;
  white-space: nowrap;
}

.base-range-selector__chevron {
  width: 12px;
  height: 12px;
  margin-left: 2px;
  opacity: 0.6;
}

@media (max-width: 640px) {
  .base-range-selector__label {
    display: none;
  }
}

@media (max-width: 575.98px) {
  .base-range-selector__btn {
    height: 32px;
    padding: 0 10px;
    font-size: 12px;
  }
  .base-range-selector__chevron {
    width: 10px;
    height: 10px;
  }
}
</style>

<style lang="scss">
// Light-mode overrides (unscoped so .white-content parent selector works)
.white-content .base-range-selector__btn {
  border-color: #e3e3e3;
  color: #525f7f;

  &:hover:not(:disabled) {
    background: rgba(0, 0, 0, 0.03);
    color: #344675;
  }

  .base-range-selector__label {
    color: rgba(0, 0, 0, 0.6);
  }

  .base-range-selector__value {
    color: #344675;
  }
}

// Active option highlight (popper renders in a portal outside the component)
.base-range-selector__popper {
  .el-dropdown-menu__item.is-active {
    color: #e14eca;
    background: rgba(225, 78, 202, 0.1);
    font-weight: 600;
  }
}

.white-content .base-range-selector__popper {
  .el-dropdown-menu__item.is-active {
    background: rgba(225, 78, 202, 0.08);
  }
}
</style>
